import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const dental_purchase = (params: StepConfigParams) => {
  return {
    stepContent: [
      {
        type: 'spinner',
      },
    ],
    isAutoSubmitStep: true,
    onPrepare: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'fetchProductLTV',
        inputs: [],
        outputs: [],
      },
    },
    subFlow: params.subFlow,
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'purchaseProduct',
        inputs: [],
        outputs: [],
      },
    },
  } as const satisfies AnyStepConfiguration
}

export default dental_purchase
